import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class Invoices_ds_invoice_editorService {

  constructor(
    private utils: UtilsService,
    private settings: SettingsValuesService,
    ) { 
  }

  public async get(inParams: { invoiceId: number }): 
  Promise<{ result: { Id?: number, AttentionOf?: string, CreatedSysDateTime?: string, CreatedSysUser?: string, CurrencyId?: number, DueDate?: string, InvoiceDate?: string, LookupCode?: string, Notes?: string, ProjectId?: number, ReferenceCode?: string, StatusId?: number, TermId?: number, TypeId?: number, Currency?: { ShortLabel?: string }, Status?: { Name?: string }, Term?: { Name?: string }, Project?: { OwnerId?: number }, InvoiceLines?: { Id?: number }[] } }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.invoiceId)) {
      missingRequiredInParams.push('\'invoiceId\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/Invoices/datasources/ds_invoice_editor/get`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }


    
    hasMissingRequiredInParams(inParams: { 
      invoiceId: number    }) {
        if(isNil(inParams.invoiceId)) {
          return true; 
        }
      return false;
    }
}
